import { render, staticRenderFns } from "./EmptyListingBox.vue?vue&type=template&id=489f5d4c"
import script from "./EmptyListingBox.vue?vue&type=script&lang=ts"
export * from "./EmptyListingBox.vue?vue&type=script&lang=ts"
import style0 from "./EmptyListingBox.vue?vue&type=style&index=0&id=489f5d4c&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports